import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ n, children }) => (
  <div className="flex items-center gap-4 font-mono text-xs tracking-[0.35em] uppercase text-[var(--gold)]">
    <span className="text-[var(--blood)]">{n}</span>
    <span className="h-px w-12 bg-[var(--gold)]/50" />
    <span>{children}</span>
  </div>
);

export const SectionTitle = ({ children }) => (
  <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6">
    {children}
  </h2>
);
